import { ArchiveMutation } from "../hooks/useArchiveState";
import { AppointmentControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchiveAppointment = () =>
  useMutationWithLoading(async (params: ArchiveMutation) =>
    new AppointmentControllerApi(
      getConfigObject()
    ).updateAppointmentArchiveStatus(
      params?.id,
      params?.status,
      params?.xTENANTID
    )
  );
